import React from "react";
import "../CSS/styles.css";
import i1 from '../../assets/i1.png';
import i2 from '../../assets/i2.png';
import i3 from '../../assets/i3.png';
import i4 from '../../assets/i4.png';
import i5 from '../../assets/i5.png';

const Our = () => {
  return (
    <div className="container py-5 mt-5">
      <div className="row justify-content-center py-lg-5 px-lg-5">
        <h1 className="mb-0 text-center bc fw-bold">Our Clients</h1>
        <p className="text-center mb-0 gc2 mt-2">We've had the privilege of working with leading organizations across industries  and regions.</p>
        <div className="col-lg-12 col-12">
          <div id="carouselExampleIndicators" className="carousel slide">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="container px-lg-5">
                  <div className="row px-lg-5 mx-5 py-lg-5 wcc align-items-center">
                    <div className="col-lg-2 mt-lg-0 mt-3 d-flex justify-content-center p-3 col-12">
                      <img src={i1} className="w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex justify-content-center">
                      <img src={i2} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i3} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i4} className=" d-block w-75" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-5 d-flex justify-content-center">
                      <img src={i5} className=" d-block w-100" alt="..." />
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="container px-lg-5">
                  <div className="row px-lg-5 mx-5 py-lg-5 wcc align-items-center">
                    <div className="col-lg-2 mt-lg-0 mt-3 d-flex justify-content-center p-3 col-12">
                      <img src={i1} className="w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex justify-content-center">
                      <img src={i2} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i3} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i4} className=" d-block w-75" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-5 d-flex justify-content-center">
                      <img src={i5} className=" d-block w-100" alt="..." />
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item ">
                <div className="container px-lg-5">
                  <div className="row px-lg-5 mx-5 py-lg-5 wcc align-items-center">
                    <div className="col-lg-2 mt-lg-0 mt-3 d-flex justify-content-center p-3 col-12">
                      <img src={i1} className="w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex justify-content-center">
                      <img src={i2} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i3} className=" d-block w-100" alt="..." />
                    </div>
                    <div className="col-lg-2 col-12 mt-lg-0 mt-4 d-flex justify-content-center">
                      <img src={i4} className=" d-block w-75" alt="..." />
                    </div>
                    <div className="col-lg-3 col-12 mt-lg-0 mt-5 d-flex justify-content-center">
                      <img src={i5} className=" d-block w-100" alt="..." />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Our